export default __webpack_public_path__ + "static/media/Instant Coffee.6822e637.png";